<script>
export default {
    name: 'MenuLink',

    props: {
        to: {
            type: Object,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },

    methods: {
        menuItemClasses(isActive, isExactActive) {
            return {
                'menu-item-active': isActive || isExactActive
            }
        }
    }
}
</script>

<template>
    <router-link
        :to="to"
        class="menu-link menu-toggle"
        v-slot="{ href, navigate, isActive, isExactActive }"
    >
        <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item menu-item-submenu"
            :class="menuItemClasses(isActive, isExactActive)"
        >
            <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon" :class="icon"></i>
                <span class="menu-text">{{ text }}</span>
            </a>
        </li>
    </router-link>
</template>

<style scoped>

</style>